const PropTypes = require('prop-types');
const React = require('react');
const APIRequest = require('components/api_request.js');
const UrlHelpers = require('components/shared/url_helpers.js');

class Form extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      body: '',
      isSubmitting: false,
    };
  }

  handleSubmit = (event) => {
    event.preventDefault();
    if (this.isSubmitDisabled) { return; }

    this.setState({ isSubmitting: true });

    APIRequest.V4.postJSON(
      UrlHelpers.createOrderNotePath,
      {
        order_id: this.props.orderId.toString(),
        body: this.state.body,
      },
    ).then(response => {
      this.setState({
        isSubmitting: false,
        body: '',
      });
      this.props.onNoteAdded(response.order_note);
    });
  }

  handleChangeBody = (event) => {
    this.setState({ body: event.target.value });
  }

  get isSubmitDisabled() {
    return this.state.body.length === 0 || this.state.isSubmitting;
  }

  render() {
    return (
      <form className="order-notes__form" onSubmit={this.handleSubmit}>
        <textarea
          className="order-notes__textarea"
          value={this.state.body}
          onChange={this.handleChangeBody}
        />

        <button
          className="order-notes__submit"
          type="submit"
          disabled={this.isSubmitDisabled}
        >
          {I18n.t('js.orderNotes.submit')}
        </button>
        <div className="order-notes__hint">
          {I18n.t('js.orderNotes.hint')}
        </div>
      </form>
    );
  }
}

Form.PropTypes = {
  orderId: PropTypes.string.isRequired,
  onNoteAdded: PropTypes.func.isRequired,
};

module.exports = Form;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/order_notes/form.jsx